/** Compact RIV display for large protocol totals (website + DApp-aligned). */
export function fmtRivCompact(n: number) {
  const v = Math.max(0, n)
  if (v >= 1_000_000_000) return `${(v / 1_000_000_000).toFixed(2)}B`
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(2)}M`
  if (v >= 1_000) return `${(v / 1_000).toFixed(1)}K`
  return Math.round(v).toLocaleString("en-US")
}

/** Share-style percent from a 0–1 ratio (investorStats retention / stickiness). */
export function fmtPctRatio(ratio: number, digits = 1) {
  if (!Number.isFinite(ratio) || ratio <= 0) return "0%"
  return `${(ratio * 100).toFixed(digits)}%`
}

export function fmtRivBurn(n: number) {
  const v = Math.max(0, n)
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(3)}M`
  if (v >= 1_000) return `${(v / 1_000).toFixed(2)}K`
  return v.toLocaleString("en-US", { maximumFractionDigits: 2 })
}
